import axios from "axios";
import {config} from "@/appconfig";

export interface Vtaetigkeitschemaupdate_form {
    CurrentSchemaVersion: number;
    SchemaUpdateInfos: SchemaUpdateInfo[];
}

export interface Vtaetigkeitschemaupdate_command {}

export interface Vtaetigkeitschemaupdate_command_result {
    CurrentSchemaVersion: number;
    AktualisierteVerarbeitungstaetigkeiten: number;
}

export interface SchemaUpdateInfo {
    SchemaVersion: number;
    AnzahlVerarbeitungstaetigkeiten: number;
}

export interface LogPage {
    Entries: LogEntry[];
    LevelFilter: number | null;
    TopicFilter: number[];
    Filter: string | null;
    Cursor: number | null;
    CursorNext: number | null;
    CursorPrev: number | null;
}

export interface LogPageRequest {    
    Cursor: number | null;
    LevelFilter: number | null;
    TopicFilter: number[];
    Filter: string | null;
    PageSize: number | null;
}

export interface LogEntry {
    Id: number;
    Timestamp: string;
    Level: number;
    Topic: number;
    Message: string;
    Details: string;
    StackTrace: string | null;
    Kunde: string;
    User: string;
    AuthorizedUser: string;
    IsException: boolean;
    Trace: string;
    Operation: string;
    Component: string;
    Expires: string;
}

export interface Statistics
{
    UTC: string;
    LogEntriesToday: number;
    LogEntriesYesterday: number;
    ErrorsToday: number;
    ErrorsYesterday: number;
    WarningsToday: number;
    WarningsYesterday: number;
    UserInteractiveWarningsToday: number;
    UserInteractiveWarningsYesterday: number;
    PerfWarningsToday: number;
    PerfWarningsYesterday: number;
    RequestsToday: number;
    RequestsYesterday: number;
    UniqueUsersToday: string[];
    UniqueUsersYesterday: string[];
    UniqueUserRequestsLast60: string[];
    UniqueUserRequestsLast30: string[];
    UniqueUserRequestsLast10: string[];
    UniqueUserRequestsLast5: string[];
}

export class OperationsService {
    public async Logtest(): Promise<string>{
        const response = await axios.post(`${config.apiUrl}/operations/log/test0`, config.apiHeaders);
        return response.data;
    }

    public async Errortest_1(): Promise<string>{
        const response = await axios.post(`${config.apiUrl}/operations/log/test1`, config.apiHeaders);
        return response.data;
    }

    public async Errortest_2(): Promise<string>{
        const response = await axios.post(`${config.apiUrl}/operations/log/test2`, config.apiHeaders);
        return response.data;
    }

    // public async DeleteAllData(): Promise<string>{
    //     const response = await axios.post(`${config.apiUrl}/kundedelete/DATENBANK_LEEREN`, config.apiHeaders);
    //     return response.data;
    // }


    public async DBWartung_Vtaetigkeitschemaupdate_form(): Promise<Vtaetigkeitschemaupdate_form>{
        const response = await axios.get(`${config.apiUrl}/operations/datenbankwartung/vtaetigkeitschemaupdate`, config.apiHeaders);
        return response.data as Vtaetigkeitschemaupdate_form;
    }

    public async DBWartung_Vtaetigkeitschemaupdate_command(data: Vtaetigkeitschemaupdate_command): Promise<Vtaetigkeitschemaupdate_command_result>{
        const response = await axios.post(`${config.apiUrl}/operations/datenbankwartung/vtaetigkeitschemaupdate`, data, config.apiHeaders);
        return response.data as Vtaetigkeitschemaupdate_command_result;
    }

    public async Log(request: LogPageRequest): Promise<LogPage>{
        const response = await axios.post(`${config.apiUrl}/operations/log`, request, config.apiHeaders);
        return response.data as LogPage;
    }

    public async Statistics(): Promise<Statistics>{
        const response = await axios.get(`${config.apiUrl}/operations/stats`, config.apiHeaders);
        return response.data as Statistics;
    }

    public async Stacktrace(id: number): Promise<string>{
        const response = await axios.get(`${config.apiUrl}/operations/stacktrace/${id}`, config.apiHeaders);
        return response.data as string;
    }

    public async DebugJSON(entity: string, id: number): Promise<string>{
        const response = await axios.get(`${config.apiUrl}/operations/json/${entity}/${id}`, config.apiHeaders);
        return response.data.data as string;
    }
}
